// extracted by mini-css-extract-plugin
module.exports = {"SystemLinksPage__title":"SystemLinksPage_SystemLinksPage__title__3CYkV"};